import { render, staticRenderFns } from "./canteenUselist.vue?vue&type=template&id=1a6d8cc3&scoped=true"
import script from "./canteenUselist.vue?vue&type=script&lang=js"
export * from "./canteenUselist.vue?vue&type=script&lang=js"
import style0 from "./canteenUselist.vue?vue&type=style&index=0&id=1a6d8cc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6d8cc3",
  null
  
)

export default component.exports